import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { IShipstationRates } from '../../interfaces';

interface ShippingRate extends IShipstationRates {
  shippingRateAmount :number;
}

@Component({
  selector: 'lum-shipping-label-rates',
  templateUrl: './shipping-label-rates.component.html',
  styleUrls: ['./shipping-label-rates.component.scss'],
})
export class ShippingLabelRatesComponent implements OnInit {
  shippingRates :ShippingRate[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public rates :ShippingRate[],
    private dialogRef :MatDialogRef<ShippingLabelRatesComponent>,
  ) {}

  ngOnInit() :void {
    this.shippingRates = this.rates.map((rate) => {
      const shipmentCost = rate?.shipmentCost || 0;
      const otherCost = rate?.otherCost || 0;

      return { ...rate, shippingRateAmount: shipmentCost + otherCost };
    });
  }

  onRateSelect(rate :IShipstationRates) {
    this.dialogRef.close(rate);
  }

  onClose() {
    this.dialogRef.close();
  }
}
